export default function showMore() {
  const showMoreWrappers = document.querySelectorAll(".show-more");

  showMoreWrappers.forEach((showMoreWrapper) => {
    const currentCount = showMoreWrapper.querySelector(".current-count");
    const totalCount = showMoreWrapper.querySelector(".total-count");
    const progressBar = showMoreWrapper.querySelector(".js-fill-progress-bar");

    // Get the initial number of items shown
    const initialCountNumber = currentCount.textContent;
    const totalCountNumber = totalCount.textContent;

    // Calculate the initial progress percentage
    const initialProgressPercentage = (initialCountNumber / totalCountNumber) * 100;

    // Set the initial progress bar width
    // eslint-disable-next-line
    progressBar.style.width = initialProgressPercentage + "%";

    // Function to update progress bar based on new data
    // eslint-disable-next-line no-unused-vars
    function updateProgressBar(newCurrentCount) {
      const progressPercentage = (newCurrentCount / totalCountNumber) * 100;

      // eslint-disable-next-line
      progressBar.style.width = progressPercentage + "%";
      currentCount.textContent = newCurrentCount;
    }

    // Simulate an AJAX call with a setTimeout (replace with your actual AJAX call)
    // eslint-disable-next-line
    /* setTimeout(() => {
      const newCurrentCount = Math.floor(Math.random() * (Number(totalCount.textContent) + 1));
      updateProgressBar(newCurrentCount);
    }, 2000); // Simulating a 2-second delay */
  });
}
